import { render, staticRenderFns } from "./TabMenuMobile.vue?vue&type=template&id=661549c5&scoped=true&"
import script from "./TabMenuMobile.vue?vue&type=script&lang=js&"
export * from "./TabMenuMobile.vue?vue&type=script&lang=js&"
import style0 from "./TabMenuMobile.vue?vue&type=style&index=0&id=661549c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661549c5",
  null
  
)

export default component.exports